import Service from "../../Services";

const Network = {
  namespaced: true,
  state: {
    form: {
      network_id: "",
      branch_id: "",
      name_th: "",
      name_en: "",
      image_path: "",
      image_path_show: "",
      image_name: "",
      is_publish: true,
      url: ""
    }
  },
  mutations: {
    GET_FORM: (state, res) => {
      state.form = res;
    },
    CLEAR_FORM_DATA: state => {
      state.form = {
        network_id: "",
        branch_id: "",
        name_th: "",
        name_en: "",
        image_path: "",
        image_path_show: "",
        image_name: "",
        is_publish: true,
        url: ""
      };
    }
  },
  actions: {
    // eslint-disable-next-line no-unused-vars
    getNetwork({ commit }, {page,search,sort_order}) {
      return Service.NetworkAPI.getNetwork(page,search,sort_order);
    },
    // eslint-disable-next-line no-unused-vars
    showNetwork({ commit }, id) {
      return Service.NetworkAPI.showNetwork(id);
    },
    // eslint-disable-next-line no-unused-vars
    saveNetwork({ commit }, { id, data }) {
      if (id) {
        return Service.NetworkAPI.updateNetwork(id, data);
      } else {
        return Service.NetworkAPI.createNetwork(data);
      }
    },
    // eslint-disable-next-line no-unused-vars
    deleteNetwork({ commit }, id) {
      return Service.NetworkAPI.deleteNetwork(id);
    },
    setFormNetwork({ commit }, res) {
      commit("GET_FORM", res);
    },
    clearFormData({ commit }) {
      commit("CLEAR_FORM_DATA");
    }
  }
};
export default Network;
